import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';

const Stats = () => {
  const [stats, setStats] = useState([
    { id: 1, value: '500+', label: 'Projects Delivered' },
    { id: 2, value: '99.9%', label: 'Uptime SLA' },
    { id: 3, value: '24/7', label: 'Support Coverage' },
    { id: 4, value: '15+', label: 'Years Experience' }
  ]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await apiService.getStats();
        if (response.data && response.data.length > 0) {
          setStats(response.data);
        }
      } catch (error) {
        console.log('Using default stats data');
      }
    };

    fetchStats();
  }, []);

  return (
    <section className="py-20 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat) => (
            <div key={stat.id} className="animate-fade-in-up">
              <div className="text-4xl font-bold mb-2">{stat.value}</div>
              <div className="text-blue-200">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
